import { Yup, TRANSLATION }  from '@/imports-files/pages/clients/recruitments/unsuccessful-reasons';

export const URL_FORMAT = /^((http|https):\/\/)?[a-zA-Z0-9]+([\-\.]{1}[a-zA-Z0-9]+)*\.[a-z]{2,}(:[0-9]{1,})?(\/.*)?$/i;

export const MANAGE_ASSESSMENT = {
  file_size: 10000000,
  texts:{
          heading_1: 'Manage Assessments',
          subheading: `Here you can manage the customised test templates which are to be sent to the candidates.`,
          placeholder:'Search for reasons',
          button: 'ADD new assessment',
          datatable:{
                    column_1: 'Unsuccessful Reasons',
                    column_2: 'Last Edited By',
                    column_3: 'Action'
                  }
        },
  manageAssessmentOptions:{   
                              'edit':{
                                              title: 'Edit'
                                      },
                              'delete':{
                                              title: 'Delete'
                                      }
                              },
  assessmentForm: {
                              formInitials:{  
                                              reason: ''
                                            },
                              formDefault:{
                                              reason: ''
                                            },
                              formValidation: Yup.object({
                                                              reason: Yup.string().required(TRANSLATION('HGH'))
                                                                                  .max(50, TRANSLATION('errors:max_50_char_error'))
                                                          }),
                              texts:{ 
                                      heading           :  'Add New Reason',
                                      add_heading       :  'Add Assessment',
                                      edit_heading      :  'Edit Assessment',
                                      label             :  'Reason',
                                      placeholder       :  'Write here',
                                      close_button      :  'Close',
                                      button_1          :  'Cancel',
                                      button_2          :  'Submit'
                                    }
                                                      
                            },
  delete_reason_modal:{
                    message: 'Deleting this assessment template will also remove it from all the associated jobs. Do you wish to proceed?',
                    action_button: 'Delete'
                  },
  assessment_initials: {
    name: '',
    file_type: 'link',
    link: '',
    file: '',
    filename: ''
  },
}

export function addAssessmentValidation(){
  let assessment_validation = {
    name: Yup.string().required(TRANSLATION('errors:required')),
    file_type: Yup.string().required(TRANSLATION('errors:required')),
    link: Yup.string().when("file_type", {
      is: (file_type) => file_type == 'link',
      then: Yup.string().matches(URL_FORMAT, TRANSLATION('errors:assessment_link_invalid')),
      otherwise: Yup.string().notRequired()
    }),
    filename: Yup.string().when("file_type", {
      is: (file_type) => file_type == 'file',
      then: Yup.string(),
      otherwise: Yup.string().notRequired()
    }),
    filesize: Yup.string().when("file_type", {
      is: (file_type) => file_type == 'file',
      then: Yup.string().test("is-greater", TRANSLATION('errors:max_file_size'), function(value) {
        let currentFileSize = parseInt(value) || 0
        return currentFileSize < MANAGE_ASSESSMENT.file_size
      }),
      otherwise: Yup.string().notRequired()
    }),
  }
  const ASSESSMENT_VALIDATION =  Yup.object(assessment_validation)
  return ASSESSMENT_VALIDATION
}

export const  setAssessmentInitial = (action, currentRow) => {
  if(action == 'create'){
    return { 
      name: '',
      file_type: 'link',
      link: '',
      file: '',
      filename: '',
      filesize: '',
    }
  }
  else {
    return { 
      id: currentRow.id,
      name: currentRow.name,
      file_type: currentRow.file_type,
      link: currentRow.file_type == 'link' ? currentRow.file_or_link : '',
      file: '',
      filename: currentRow.file_name || '',
      filesize: '',
    }
  }
}